export const ReviewCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  width: '100%',
  transition: 'all 0.2s ease',

  ReviewHeader: {
    flow: 'x',
    align: 'center space-between',

    AuthorInfo: {
      flow: 'x',
      gap: 'Z',
      align: 'center flex-start',

      Avatar: {
        width: 'C',
        height: 'C',
        round: 'C',
        background: 'teal.15',
        flow: 'x',
        align: 'center center',
        flexShrink: '0',
        Initial: {
          text: (el, s) => {
            const name = s.anonymous ? '?' : (s.patientName || '?')
            return name.charAt(0).toUpperCase()
          },
          fontSize: 'Z',
          fontWeight: '700',
          color: 'teal'
        }
      },

      NameDate: {
        flow: 'y',
        gap: 'W',
        AuthorName: {
          text: (el, s) => s.anonymous ? '{{ anonymousPatient | polyglot }}' : (s.patientName || '{{ anonymousPatient | polyglot }}'),
          fontSize: 'Z',
          fontWeight: '600',
          color: 'inkText'
        },
        ReviewDate: {
          text: (el, s) => s.date || '',
          fontSize: 'Y',
          color: 'inkMuted'
        }
      }
    },

    StarDisplay: {
      flow: 'x',
      gap: 'W',
      children: (el, s) => {
        const rating = s.rating || 0
        return Array.from({ length: 5 }, (_, i) => ({ filled: i < Math.round(rating) }))
      },
      childrenAs: 'state',
      childProps: {
        extends: 'Icon',
        icon: 'star',
        width: 'Z',
        height: 'Z',
        color: (el, s) => s.filled ? 'teal' : 'inkBorder'
      }
    }
  },

  ReviewText: {
    text: (el, s) => s.text || '',
    fontSize: 'Z',
    color: 'inkSubtle',
    lineHeight: '1.7'
  },

  CategoryBadges: {
    flow: 'x',
    gap: 'Y',
    flexWrap: 'wrap',
    show: (el, s) => s.categories && Object.keys(s.categories).length > 0,
    children: (el, s) => {
      if (!s.categories) return []
      const labels = {
        professionalism: 'Professionalism',
        painManagement: 'Pain Mgmt',
        explanationQuality: 'Explanation',
        punctuality: 'Punctuality'
      }
      return Object.entries(s.categories).map(([key, val]) => ({
        label: labels[key] || key,
        value: val
      }))
    },
    childrenAs: 'state',
    childProps: {
      flow: 'x',
      gap: 'W',
      align: 'center center',
      padding: 'W Y',
      round: 'C',
      background: 'inkSurface',
      BadgeLabel: { text: (el, s) => s.label, fontSize: 'Y', color: 'inkSubtle' },
      BadgeStar: { extends: 'Icon', icon: 'star', width: 'Y', height: 'Y', color: 'teal' },
      BadgeVal: { text: (el, s) => String(s.value), fontSize: 'Y', fontWeight: '600', color: 'inkText' }
    }
  },

  DoctorResponse: {
    flow: 'y',
    gap: 'Y',
    padding: 'Z A',
    marginTop: 'Y',
    borderLeft: '2px solid teal',
    background: 'teal.05',
    round: '0 Y Y 0',
    show: (el, s) => !!s.doctorResponse,

    ResponseLabel: {
      flow: 'x',
      gap: 'Y',
      align: 'center flex-start',
      DocIcon: { extends: 'Icon', icon: 'user', width: 'Y', height: 'Y', color: 'teal' },
      DocLabel: { text: '{{ doctorResponse | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'teal' }
    },
    ResponseText: {
      text: (el, s) => s.doctorResponse || '',
      fontSize: 'Z',
      color: 'inkSubtle',
      lineHeight: '1.6'
    }
  },

  VoteRow: {
    flow: 'x',
    gap: 'Z',
    align: 'center flex-start',
    marginTop: 'Y',

    HelpfulLabel: { text: '{{ helpfulQuestion | polyglot }}', fontSize: 'Y', color: 'inkMuted' },

    HelpfulBtn: {
      flow: 'x',
      gap: 'W',
      align: 'center center',
      padding: 'W Y',
      round: 'Y',
      cursor: 'pointer',
      background: 'transparent',
      border: '1px solid inkBorder',
      transition: 'all 0.15s ease',
      ':hover': { background: 'teal.1', borderColor: 'teal' },
      onClick: (e, el, s) => {
        const current = s.helpfulCount || 0
        s.update({ helpfulCount: current + 1 })
      },
      ThumbUp: { extends: 'Icon', icon: 'thumbsUp', width: 'Y', height: 'Y', color: 'inkMuted' },
      HelpfulCount: { text: (el, s) => String(s.helpfulCount || 0), fontSize: 'Y', color: 'inkMuted' }
    },

    NotHelpfulBtn: {
      flow: 'x',
      gap: 'W',
      align: 'center center',
      padding: 'W Y',
      round: 'Y',
      cursor: 'pointer',
      background: 'transparent',
      border: '1px solid inkBorder',
      transition: 'all 0.15s ease',
      ':hover': { background: 'crimson.1', borderColor: 'crimson' },
      onClick: (e, el, s) => {
        const current = s.notHelpfulCount || 0
        s.update({ notHelpfulCount: current + 1 })
      },
      ThumbDown: { extends: 'Icon', icon: 'thumbsDown', width: 'Y', height: 'Y', color: 'inkMuted' },
      NotHelpfulCount: { text: (el, s) => String(s.notHelpfulCount || 0), fontSize: 'Y', color: 'inkMuted' }
    }
  }
}
